import React, { useState } from 'react';
import { FadeIn } from './Shared';
import { Plus, Minus } from 'lucide-react';
const AccordionItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-white/5 last:border-0" data-id="element-68">
      <button className="w-full py-8 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-69">
        <span className={`text-lg md:text-xl font-bold transition-colors duration-300 pr-8 font-sans leading-snug ${isOpen ? 'text-pink-400' : 'text-white'}`} data-id="element-70">
          {question}
        </span>
        <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 shrink-0 ${isOpen ? 'bg-pink-500 text-navy-950 rotate-180' : 'bg-white/5 text-pink-400'}`} data-id="element-71">
          {isOpen ? <Minus className="w-4 h-4" data-id="element-72" /> : <Plus className="w-4 h-4" data-id="element-73" />}
        </div>
      </button>
      <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[500px] pb-8 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-74">
        <p className="text-gray-200 leading-relaxed text-base md:text-lg font-sans opacity-95 border-l-2 border-pink-500/30 pl-6 py-2" data-id="element-75">
          {answer}
        </p>
      </div>
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Funciona si vendo solo por WhatsApp y no tengo local ni showroom físico?',
    a: 'Sí. El sistema está diseñado específicamente para ventas por WhatsApp e Instagram. No necesitás local, sistema de punto de venta ni nada físico. Solo tu celular y las herramientas del método.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de confirmar el pago recibís un email con el link de descarga. Todo en PDF. Podés leerlo desde el celular, la tablet o la computadora. También podés imprimirlo.'
  }, {
    q: '¿Funciona si vendo ropa, calzado, accesorios, bijou o carteras?',
    a: 'Sí. El sistema fue diseñado para cualquier emprendedora que vende productos físicos y maneja pedidos, stock, señas y entregas. No importa la categoría del producto.'
  }, {
    q: '¿Y si soy muy desorganizada? ¿Puedo aplicarlo igual?',
    a: 'Especialmente para vos. El sistema está diseñado para empezar desde cero. No requiere planillas previas ni hábitos instalados. Cada herramienta tiene instrucciones de uso que te llevan de la mano.'
  }, {
    q: '¿Qué lo diferencia de un curso de ventas o de marketing?',
    a: 'Es completamente diferente. No te enseña a conseguir más clientas ni a hacer publicidad. Te enseña a no perder plata con las clientas que ya tenés: a registrar bien los pedidos, cobrar bien las señas, controlar el stock y saber cuánto ganás realmente cada semana.'
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días de garantía completa. Si no es lo que esperabas, devolvemos el 100% sin preguntas ni formularios. El riesgo es nuestro, no tuyo.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-76">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-77">
        <FadeIn data-id="element-78">
          <div className="flex flex-col items-center mb-16" data-id="element-79">
            <div className="bg-white/5 text-gray-400 px-6 py-2 rounded-full border border-white/10 text-xs font-bold tracking-[0.2em] mb-6 uppercase" data-id="element-80">
              DESPEJÁ TUS DUDAS
            </div>
            <h2 className="text-3xl md:text-5xl text-center text-white leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-81">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h2>
          </div>
          <div className="bg-navy-950 rounded-3xl border border-white/10 p-8 md:p-12" data-id="element-82">
            {faqs.map((faq, index) => <AccordionItem key={index} question={faq.q} answer={faq.a} data-id="element-83" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
};